module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content_all2",
    attrs: {
      "id": "site_int"
    }
  }, [_c('div', {
    staticClass: "content_box"
  }, [_c('div', {
    staticClass: "site_inqbox"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("場館名稱")]), _vm._v(" "), _c('td', [_c('Select', {
    staticStyle: {
      "width": "150px"
    },
    on: {
      "on-change": _vm.getVenue
    },
    model: {
      value: (_vm.buildingId),
      callback: function($$v) {
        _vm.buildingId = $$v
      },
      expression: "buildingId"
    }
  }, _vm._l((_vm.building), function(build, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": build.id
      }
    }, [_vm._v(_vm._s(build.buildingName))])
  })), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.venuesId),
      callback: function($$v) {
        _vm.venuesId = $$v
      },
      expression: "venuesId"
    }
  }, _vm._l((_vm.venues), function(venue, index) {
    return (venue.buildingId === _vm.buildingId) ? _c('Option', {
      key: index,
      attrs: {
        "value": venue.id
      }
    }, [_vm._v(_vm._s(venue.venueName))]) : _vm._e()
  }))], 1)])])]), _vm._v(" "), (_vm.venuesId) ? _c('div', {
    staticClass: "list_box2",
    domProps: {
      "innerHTML": _vm._s(_vm.showVenues.description)
    }
  }) : _c('div', {
    staticClass: "list_box2"
  }, [_c('p', {
    staticStyle: {
      "color": "#bbb",
      "font-style": "italic"
    }
  }, [_vm._v("請選擇場館")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bc733fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rent/SiteInt.vue
// module id = 1217
// module chunks = 3